var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-input"},[_c('select',{ref:"input",on:{"change":function($event){return _vm.$emit('update:response', _vm.$refs.input.value)}}},_vm._l((_vm.options),function(option){return _c('option',{key:option,domProps:{"value":option,"textContent":_vm._s(option)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }